import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
/**
 * Amount of nested layouts
 *
 * Layout nesting occurs when using embedded configuration objects
 *
 * @private
 */
const LayoutDepthContext = createContext(0);
LayoutDepthContext.displayName = "LayoutDepthContext";
/**
 *
 * @param props
 * @returns
 */
export function NestedLayout(props) {
    const currentDepth = useContext(LayoutDepthContext);
    return (_jsx(LayoutDepthContext.Provider, { value: currentDepth + 1, children: props.children }));
}
/**
 * Get current level of nesting
 * @returns
 */
export function useLayoutDepth() {
    return useContext(LayoutDepthContext);
}
/**
 * Get current level of nesting
 * @returns
 */
export function useIsNestedLayout() {
    return useLayoutDepth() > 0;
}
//# sourceMappingURL=NestedLayout.js.map